var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("FormEditor", {
        attrs: { viewModel: _vm.formEditor },
        on: { "save-form": _vm.handleCreateFormCommand },
      }),
      _vm._v(" "),
      _c("PortfolioNavigation", {
        attrs: { workspaceId: _vm.workspaceId, projectId: _vm.projectId },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "container",
          staticStyle: { "margin-top": "80px", "padding-top": "40px" },
        },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-lg-6" }, [
              _c("h6", [
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/pp/pages/${_vm.workspaceId}/${_vm.projectId}`,
                        expression: "`/#/pp/pages/${workspaceId}/${projectId}`",
                      },
                    ],
                    staticClass: "text-dark",
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-angle-double-left",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v(" Back to pages\n                    "),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "h1",
                {
                  staticStyle: {
                    "font-size": "2em",
                    "font-weight": "300",
                    color: "#33475b",
                    margin: "0",
                  },
                },
                [_vm._v("Edit request page")]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-6 text-right" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-success",
                  staticStyle: { padding: "0.7em 2em" },
                  attrs: { role: "button" },
                  on: { click: _vm.handleUpdateRequestPageCommand },
                },
                [_vm._v("Save changes")]
              ),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("hr", {
        staticStyle: { "border-color": "#bbb", margin: "20px 0 60px" },
      }),
      _vm._v(" "),
      _vm.rm
        ? _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("Name:")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.rm.Name,
                    expression: "rm.Name",
                    modifiers: { trim: true },
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.rm.Name },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.rm, "Name", $event.target.value.trim())
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
              _vm._v(" "),
              _c("small", [_vm._v("Name of the page.")]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("Logo url:")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.rm.LogoUrl,
                    expression: "rm.LogoUrl",
                    modifiers: { trim: true },
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.rm.LogoUrl },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.rm, "LogoUrl", $event.target.value.trim())
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
              _vm._v(" "),
              _c("small", [
                _vm._v(
                  "Enter url of your logo. Logo will be displayed on your project request page. By default - TransparentChoice's logo."
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("label", [_vm._v("Form:")]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-lg-6 col-md-6" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.rm.FormId,
                          expression: "rm.FormId",
                        },
                      ],
                      staticClass: "form-control",
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.rm,
                            "FormId",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    _vm._l(_vm.rm.Forms, function (f) {
                      return _c("option", { domProps: { value: f.Id } }, [
                        _vm._v(_vm._s(f.Name)),
                      ])
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("small", [
                    _vm._v(
                      "Choose a form that will be used to collect requests."
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-4 col-lg-4" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-secondary",
                    attrs: { type: "button" },
                    on: { click: _vm.showFormCreator },
                  },
                  [_vm._v("New form")]
                ),
                _vm._v(" "),
                _vm.rm.FormId
                  ? _c(
                      "a",
                      {
                        staticClass: "btn btn-outline-secondary",
                        attrs: {
                          target: "_blank",
                          href: `/#/pp/edit-form/${_vm.workspaceId}/${_vm.projectId}/${_vm.rm.FormId}`,
                        },
                      },
                      [_vm._v("Edit form")]
                    )
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("hr", { staticStyle: { margin: "1em 0" } }),
            _vm._v(" "),
            _c("h4", [_vm._v("Content:")]),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("Editor", {
                  ref: "editor",
                  attrs: {
                    tools: _vm.tools,
                    "content-style": { height: "490px" },
                    "default-content": _vm.rm.ContentHtml,
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }